import React from 'react';
import { SearchOutlined } from '@teko/ds-icon';
import { Container, Title, Flex, Body, styled } from '@teko/ds-desktop';
import { t } from '../../i18n.es.js';

const RecentSearch = ({
  data,
  onClickSearchItem
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !!data.length && /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Title, {
    marginBottom: "s8"
  }, t("T\xECm ki\u1EBFm g\u1EA7n \u0111\xE2y")), /* @__PURE__ */ React.createElement(ContentWrapper, null, data.map((history, index) => /* @__PURE__ */ React.createElement(Flex, {
    key: index,
    marginRight: "s8",
    borderRadius: "m",
    borderWeight: "l",
    borderColor: "divider",
    borderStyle: "solid",
    padding: "s8",
    maxWidth: "40vw",
    align: "center",
    onClick: () => onClickSearchItem(history.query)
  }, /* @__PURE__ */ React.createElement(SearchOutlined, {
    size: 24,
    style: { minWidth: 24 },
    color: "textSecondary"
  }), /* @__PURE__ */ React.createElement(Body, {
    width: "70%",
    line: 2,
    marginLeft: "s8"
  }, history.query))))));
};
const ContentWrapper = styled.div`
  display: -webkit-inline-box;
  width: 100%;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export { RecentSearch };
